module.exports = __webpack_public_path__ + "img/NationalAcademyOfSciencesLogo.05dad6dd.png";